import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { animated, useSprings } from 'react-spring';
import { clamp, mapValue } from '@spa/shared/utils/math';
import { Svg } from './styles';

const width = 50;
const height = 10;

const Histogram = ({ data, range: [minRange, maxRange] }) => {
  const max = useMemo(() => Math.max(...Object.values(data)) || 1, [data]);

  const keys = useMemo(() => Object.keys(data), [data]);
  const isOutsideRange = useCallback(
    value => {
      if (!minRange && !maxRange) {
        return;
      }

      return value < minRange || value > maxRange;
    },
    [minRange, maxRange]
  );

  const styles = useSprings(
    keys.length,
    keys.map(key => {
      const value = data[key];

      return {
        from: {
          height: 0
        },
        to: {
          height: clamp(mapValue(value, 0, max, 0, height), 0, height)
        }
      };
    })
  );

  return (
    <Svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox={`0 0 ${width} ${height}`} role="img">
      <g transform={`translate(0,${height}) scale(1,-1)`}>
        {keys.map((key, index) => (
          <g key={key} className={`bar ${isOutsideRange(key) ? 'outside' : ''}`}>
            <animated.rect
              x={Math.floor(mapValue(index, 0, keys.length, 0, width))}
              width={width / keys.length}
              height={styles[index].height}
            />
          </g>
        ))}
      </g>
    </Svg>
  );
};

Histogram.propTypes = {
  data: PropTypes.object.isRequired,
  range: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number
};

export default Histogram;
